<div class="wrapper">
    <app-humi-logo size="medium" labelOrientation="horizontal"></app-humi-logo>
    <h1>{{ 'errorPage' | appTranslate }}</h1>
    <p>{{ 'cantFindPage' | appTranslate }}</p>
    <ui-button type="primary" [url]="'/'">{{ 'returnHome' | appTranslate }}</ui-button>
</div>
